import { useSelector } from 'react-redux';

import { useApiQuery } from 'theSource/utils';
import { selectIsAuthenticated } from 'theSource/features';
import {
  AvailablePlanYearsResponseDto,
  GET_AVAIL_PLAN_YEARS_QUERY_KEY,
} from './utils';

export interface UseAvailablePlanYearsQueryOutput {
  availablePlanYears: AvailablePlanYearsResponseDto;
  isLoadingAvailablePlanYears: boolean;
  isFetchingAvailablePlanYears: boolean;
}

export const useAvailablePlanYearsQuery =
  (): UseAvailablePlanYearsQueryOutput => {
    const isAuthenticated = useSelector(selectIsAuthenticated);

    const {
      data: availablePlanYears,
      isLoading: isLoadingAvailablePlanYears,
      isFetching: isFetchingAvailablePlanYears,
    } = useApiQuery<any>({
      queryKey: GET_AVAIL_PLAN_YEARS_QUERY_KEY,
      endpoint: '/life_events/available_plan_years',
      enabled: Boolean(isAuthenticated),
    });

    return {
      availablePlanYears,
      isLoadingAvailablePlanYears,
      isFetchingAvailablePlanYears,
    };
  };
